import React from 'react';
import Icon from '../../../components/common/Icon/Icon';
import PlanNameWithProject from '../../../components/common/PlanNameWithProject/PlanNameWithProject';
import { formatCurrency } from '../../../utils';
import type { CheckoutPlanLike, PaymentMethod } from '../checkout.types';
import {
  calculateCheckoutTotalCents,
  getBillingCyclePriceSuffix,
  getPaymentMethodLabel,
  getRecurringBillingLabel,
} from '../checkout.utils';
import SecurityNotice from './SecurityNotice';
import styles from './CheckoutShared.module.css';

interface PaymentSummaryCardProps {
  selectedPlan: CheckoutPlanLike | null;
  discountCents: number;
  paymentMethod?: PaymentMethod | null;
}

const PaymentSummaryCard: React.FC<PaymentSummaryCardProps> = ({
  selectedPlan,
  discountCents,
  paymentMethod = null,
}) => {
  const subtotalCents = selectedPlan?.price_cents ?? 0;
  const totalCents = calculateCheckoutTotalCents(selectedPlan, discountCents);

  return (
    <section className={styles.summaryCard} aria-label="Dados do plano">
      <h2 className={styles.summaryTitle}>Dados do plano</h2>
      <SecurityNotice placement="belowLabel" />

      {!selectedPlan ? (
        <p className={styles.summaryEmpty}>
          
        </p>
      ) : (
        <>
          <p className={styles.summaryPlanName}>
            <PlanNameWithProject name={selectedPlan.name} project={selectedPlan.project} />
          </p>
          <p className={styles.summaryPrice}>
            {formatCurrency(subtotalCents / 100)}
            {getBillingCyclePriceSuffix(selectedPlan.billing_cycle)}
          </p>
          <p className={styles.summaryRecurring}>
            <Icon name="check_circle" size={16} className={styles.summaryRecurringIcon} aria-hidden />
            {getRecurringBillingLabel(selectedPlan)}
          </p>

          {discountCents > 0 && (
            <div className={styles.summaryRow}>
              <span className={styles.summaryLabel}>Desconto</span>
              <span className={styles.summaryValue}>
                - {formatCurrency(discountCents / 100)}
              </span>
            </div>
          )}

          {paymentMethod && (
            <div className={styles.summaryRow}>
              <span className={styles.summaryLabel}>Pagamento</span>
              <span className={styles.summaryValue}>
                {getPaymentMethodLabel(paymentMethod)}
              </span>
            </div>
          )}

          <hr className={styles.summaryDivider} />

          <div className={styles.summaryTotal}>
            <span>Total</span>
            <span>
              {formatCurrency(totalCents / 100)}
              {getBillingCyclePriceSuffix(selectedPlan.billing_cycle)}
            </span>
          </div>
        </>
      )}
    </section>
  );
};

export default PaymentSummaryCard;
